import React, { useState } from "react";
import { Box } from "@mui/material";
import FeedbackDialog from "./FeedbackDialog";

const MoreToCome = ({ user }) => {
  const [contactDialogOpen, setContactDialogOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          textAlign: "center",
          mt: 10,
          color: "text.secondary",
          fontSize: "0.9rem", // Added font size here
        }}
      >
        Saknar du något alternativ här?{" "}
        <Box
          component="span"
          sx={{
            color: "primary.main",
            cursor: "pointer",
            fontWeight: 500,
            textDecoration: "none",
            display: "inline",
            fontSize: "0.9rem", // Added font size here too for consistency
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => setContactDialogOpen(true)}
        >
          Ge oss feedback :)
        </Box>
      </Box>
      <FeedbackDialog
        open={contactDialogOpen}
        onClose={() => setContactDialogOpen(false)}
        user={user}
        contactForm="true"
      />
    </>
  );
};

export default MoreToCome;
